module.exports = __webpack_public_path__ + "static/media/bill-happy.15241460.svg";